import { FC, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Group } from '@mantine/core';
import { TestS } from '../../TestS';
import { EventContext } from '../../Service/Context/EventContext';
import { openDeleteEventModal } from './EventModals';

const EventHeadActions: FC<{ closeNavBar: () => void }> = ({ closeNavBar }) => {
  const navigate = useNavigate();
  const { copyHandler } = useContext<any>(EventContext);
  const { id: eventId } = useParams();
  const onDelete = () => navigate('/');

  const onClick = () => {
    closeNavBar();
    openDeleteEventModal({ eventId: eventId ?? '', onDelete });
  };

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {eventId !== '' && (
        <Group position="center" spacing="xs">
          <Button variant="subtle" onClick={copyHandler}>
            Event duplizieren
          </Button>
          <Button color="red" variant="subtle" onClick={onClick} data-testid={TestS.Events.Delete.DELETE}>
            Event löschen
          </Button>
        </Group>
      )}
    </>
  );
};

export default EventHeadActions;
